
import { baseUrl_SPB} from '../../BaseUrl'
async function retrievesubsciptiondetails(token) {

    let tokenv = token;

    try {
        const response = await fetch(`${baseUrl_SPB}/api/v1/subscribe/retrievesubscriptiondetails`, {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenv
            },

        });

        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        console.error('Error:', error);
    }
}

async function getinvoices(token) {

    let tokenv = token;

    try {
        const response = await fetch(`${baseUrl_SPB}/api/v1/subscribe/getinvoices`, {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenv
            },

        });

        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        console.error('Error:', error);
    }
}

async function cancelsubscription(token) {

    let tokenv = token;

    try {
        const response = await fetch(`${baseUrl_SPB}/api/v1/subscribe/cancelsubscription`, {
            method: 'POST',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenv
            },

        });

        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        console.error('Error:', error);
    }
}

export { retrievesubsciptiondetails,cancelsubscription,getinvoices };